import { render, staticRenderFns } from "./PlanPractice.vue?vue&type=template&id=1ea4f679&"
import script from "./PlanPractice.vue?vue&type=script&lang=js&"
export * from "./PlanPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports